
export const MAIN_API_URL = process.env.NODE_ENV === 'production' ? 'https://api.creativeocto.io' : 'http://localhost:5080';
export const FRONTEND_URL = 'http://localhost:3001';
export const API_URL = process.env.NODE_ENV === 'production' ? 'https://api.creativeocto.io/api/admin' : 'http://localhost:5080/api/admin';
export const BACKEND_URL = process.env.NODE_ENV === 'production' ? 'https://api.creativeocto.io/' : 'http://192.168.2.78:5080/';

// export const API_URL = 'https://api.creativeocto.io/api/admin'